import React from 'react';
import { Sparkles, Dna, Heart } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CollapsibleSection } from './CollapsibleSection';

export const ThreePillars = ({ isOpen, onToggle }) => {
  const { t } = useLanguage();

  const pillars = [
    {
      icon: <Sparkles className="w-6 h-6 text-pink-400" />,
      title: 'Rainbow Room',
      status: t('pillarStatusPrivateBeta'),
      statusColor: 'bg-gradient-to-r from-sky-400 to-indigo-400 text-white',
      description: t('pillarRainbowRoomDesc'),
      gradient: 'from-pink-500/10 to-cyan-400/10',
      link: 'https://rainbow-room-seven.vercel.app/'
    },
    {
      icon: <Dna className="w-6 h-6 text-emerald-400" />,
      title: t('pillarSupaGeneTitle'),
      status: t('pillarStatusFuture'),
      statusColor: 'bg-slate-700 text-slate-300',
      description: t('pillarSupaGeneDesc'),
      gradient: 'from-emerald-500/10 to-slate-950/10'
    },
    {
      icon: <Heart className="w-6 h-6 text-fuchsia-400" />,
      title: t('pillarCommunityFundingTitle'),
      status: t('pillarStatusFuture'),
      statusColor: 'bg-slate-700 text-slate-300',
      description: t('pillarCommunityFundingDesc'),
      gradient: 'from-fuchsia-500/10 to-slate-950/10'
    }
  ];

  return (
    <CollapsibleSection
      id="pillars-section"
      eyebrow={t('pillarsCoreLanes')}
      title={t('pillarsHeading')}
      isOpen={isOpen}
      onToggle={onToggle}
      testId="three-pillars-toggle"
    >
      <p className="mb-4 text-xs text-slate-500">{t('pillarsLegend')}</p>
      <div className="grid gap-6 md:grid-cols-3">
        {pillars.map((pillar, index) => (
          <div
            key={index}
            className="rounded-2xl p-6 bg-slate-900/60 border border-slate-700/50 hover:border-slate-600/50 hover:bg-slate-900/80 transition-colors duration-300"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${pillar.gradient} flex items-center justify-center flex-shrink-0`}>
                {pillar.icon}
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-base font-semibold text-white">{pillar.title}</h3>
                  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-medium ${pillar.statusColor}`}>
                    {pillar.status}
                  </span>
                </div>
                <p className="text-sm text-slate-400 leading-relaxed">{pillar.description}</p>
                {pillar.link && (
                  <a
                    href={pillar.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="three-pillars-enter-rainbow-room-link"
                    className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-sky-300 hover:text-sky-200 transition-colors"
                  >
                    {t('pillarEnterBeta')}
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CollapsibleSection>
  );
};
